import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <ul class="search-menu-initial-options">
  <PluginOutlet
    @name="search-menu-initial-options"
    @outletArgs={{hash
      termMatchesContextTypeKeyword=this.termMatchesContextTypeKeyword
      contextTypeComponent=this.contextTypeComponent
      slug=this.slug
      suggestionKeyword=this.contextTypeKeyword
      results=this.initialResults
      withInLabel=this.withInLabel
      suffix=this.suffix
      label=this.label
      closeSearchMenu=@closeSearchMenu
      searchTermChanged=@searchTermChanged
    }}
  >
    {{#if this.termMatchesContextTypeKeyword}}
      <SearchMenu::Results::AssistantItem
        @slug={{this.slug}}
        @extraHint={{true}}
        @closeSearchMenu={{@closeSearchMenu}}
        @searchTermChanged={{@searchTermChanged}}
        @suggestionKeyword={{this.contextTypeKeyword}}
      />
    {{else}}
      {{#if (or this.search.activeGlobalSearchTerm this.search.searchContext)}}
        {{#if this.search.activeGlobalSearchTerm}}
          <SearchMenu::Results::AssistantItem
            @suffix={{i18n "search.in_topics_posts"}}
            @closeSearchMenu={{@closeSearchMenu}}
            @searchAllTopics={{true}}
            @extraHint={{true}}
            @searchTermChanged={{@searchTermChanged}}
            @suggestionKeyword={{this.contextTypeKeyword}}
          />
        {{/if}}

        {{#if this.search.searchContext}}
          <this.contextTypeComponent
            @slug={{this.slug}}
            @suggestionKeyword={{this.contextTypeKeyword}}
            @results={{this.initialResults}}
            @withInLabel={{this.withInLabel}}
            @suffix={{this.suffix}}
            @label={{this.label}}
            @closeSearchMenu={{@closeSearchMenu}}
            @searchTermChanged={{@searchTermChanged}}
          />

          {{#if
            (and
              this.currentUser
              this.siteSettings.log_search_queries
              this.displayInitialOptions
            )
          }}
            <SearchMenu::Results::RecentSearches
              @closeSearchMenu={{@closeSearchMenu}}
              @searchTermChanged={{@searchTermChanged}}
            />
          {{/if}}
        {{/if}}
      {{else}}
        <SearchMenu::Results::RandomQuickTip
          @searchTermChanged={{@searchTermChanged}}
        />
        {{#if (and this.currentUser this.siteSettings.log_search_queries)}}
          <SearchMenu::Results::RecentSearches
            @closeSearchMenu={{@closeSearchMenu}}
            @searchTermChanged={{@searchTermChanged}}
          />
        {{/if}}
      {{/if}}
    {{/if}}
  </PluginOutlet>
</ul>
*/
{
  "id": "QwWZPreb",
  "block": "[[[10,\"ul\"],[14,0,\"search-menu-initial-options\"],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@name\",\"@outletArgs\"],[\"search-menu-initial-options\",[28,[37,1],null,[[\"termMatchesContextTypeKeyword\",\"contextTypeComponent\",\"slug\",\"suggestionKeyword\",\"results\",\"withInLabel\",\"suffix\",\"label\",\"closeSearchMenu\",\"searchTermChanged\"],[[30,0,[\"termMatchesContextTypeKeyword\"]],[30,0,[\"contextTypeComponent\"]],[30,0,[\"slug\"]],[30,0,[\"contextTypeKeyword\"]],[30,0,[\"initialResults\"]],[30,0,[\"withInLabel\"]],[30,0,[\"suffix\"]],[30,0,[\"label\"]],[30,1],[30,2]]]]]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"termMatchesContextTypeKeyword\"]],[[[1,\"      \"],[8,[39,3],null,[[\"@slug\",\"@extraHint\",\"@closeSearchMenu\",\"@searchTermChanged\",\"@suggestionKeyword\"],[[30,0,[\"slug\"]],true,[30,1],[30,2],[30,0,[\"contextTypeKeyword\"]]]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,4],[[30,0,[\"search\",\"activeGlobalSearchTerm\"]],[30,0,[\"search\",\"searchContext\"]]],null],[[[41,[30,0,[\"search\",\"activeGlobalSearchTerm\"]],[[[1,\"          \"],[8,[39,3],null,[[\"@suffix\",\"@closeSearchMenu\",\"@searchAllTopics\",\"@extraHint\",\"@searchTermChanged\",\"@suggestionKeyword\"],[[28,[37,5],[\"search.in_topics_posts\"],null],[30,1],true,true,[30,2],[30,0,[\"contextTypeKeyword\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"search\",\"searchContext\"]],[[[1,\"          \"],[8,[30,0,[\"contextTypeComponent\"]],null,[[\"@slug\",\"@suggestionKeyword\",\"@results\",\"@withInLabel\",\"@suffix\",\"@label\",\"@closeSearchMenu\",\"@searchTermChanged\"],[[30,0,[\"slug\"]],[30,0,[\"contextTypeKeyword\"]],[30,0,[\"initialResults\"]],[30,0,[\"withInLabel\"]],[30,0,[\"suffix\"]],[30,0,[\"label\"]],[30,1],[30,2]]],null],[1,\"\\n\\n\"],[41,[28,[37,6],[[30,0,[\"currentUser\"]],[30,0,[\"siteSettings\",\"log_search_queries\"]],[30,0,[\"displayInitialOptions\"]]],null],[[[1,\"            \"],[8,[39,7],null,[[\"@closeSearchMenu\",\"@searchTermChanged\"],[[30,1],[30,2]]],null],[1,\"\\n\"]],[]],null]],[]],null]],[]],[[[1,\"        \"],[8,[39,8],null,[[\"@searchTermChanged\"],[[30,2]]],null],[1,\"\\n\"],[41,[28,[37,6],[[30,0,[\"currentUser\"]],[30,0,[\"siteSettings\",\"log_search_queries\"]]],null],[[[1,\"          \"],[8,[39,7],null,[[\"@closeSearchMenu\",\"@searchTermChanged\"],[[30,1],[30,2]]],null],[1,\"\\n\"]],[]],null]],[]]]],[]]],[1,\"  \"]],[]]]]],[1,\"\\n\"],[13]],[\"@closeSearchMenu\",\"@searchTermChanged\"],false,[\"plugin-outlet\",\"hash\",\"if\",\"search-menu/results/assistant-item\",\"or\",\"i18n\",\"and\",\"search-menu/results/recent-searches\",\"search-menu/results/random-quick-tip\"]]",
  "moduleName": "discourse/components/search-menu/results/initial-options.hbs",
  "isStrictMode": false
});